<template>
    <div>
        <form-group label="Date" name="date" :required="true">
            <datepicker v-model="expense.date" :max-date="maxDate"/>
        </form-group>

        <form-group label="Currency Used" name="currency" :required="true">
            <div class="select">
                <select v-model="expense.currency" id="currency" class="input">
                    <option :value="null" disabled>Select a currency</option>
                    <option v-for="currency in commonCurrencies">
                        {{currency.currency}}
                    </option>
                    <option disabled>––</option>
                    <option v-for="name in sortedCurrencies">
                        {{name}}
                    </option>
                </select>
            </div>
        </form-group>

        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2">
                <form-group label="Total Amount" name="amount.0" :required="true">
                    <div class="flex">
                        <input type="number"
                               min="0"
                               step="1"
                               placeholder="0"
                               class="input text-right amount-int-input"
                               v-model="expense.amount[0]"
                               pattern="[0-9]{*}">
                        <div class="input-group-addon">,</div>
                        <input type="number" min="0" step="1" class="input w-16" v-model="expense.amount[1]"
                               pattern="([0-9]|[0-9])">
                    </div>
                    <div class="help-text text-red" v-if="hasError('amount')" v-html="getError('amount')"></div>
                </form-group>
            </div>
        </div>

        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2">
                <form-group label="Meal Deduction Total Amount" name="deduction.0" :required="true">
                    <div class="flex">
                        <input type="number"
                               min="0"
                               step="1"
                               placeholder="0"
                               class="input text-right amount-int-input"
                               v-model="expense.deduction[0]"
                               pattern="[0-9]{*}">
                        <div class="input-group-addon">,</div>
                        <input type="number" min="0" step="1" class="input w-16" v-model="expense.deduction[1]"
                               pattern="([0-9]|[0-9])">
                    </div>
                    <div class="help-text text-red" v-if="hasError('deduction')" v-html="getError('deduction')"></div>
                </form-group>
            </div>
        </div>

        <form-group label="Attachments" name="attachments" :required="true">
            <file-upload :url="fileUploadUrl"
                         :deleteUrl="fileDeleteUrl"
                         v-model="expense.attachments"
                         @activeFileUpload="$emit('activeFileUpload', $event)">
            </file-upload>
        </form-group>

    </div>
</template>

<script>

import {mapState} from "vuex";
import Form from './form';
import InteractsWithDates from '@/mixins/InteractsWithDates';
import FileUpload from "@/components/DragUpload";

export default {
    mixins: [Form, InteractsWithDates],

    components: {
        FileUpload
    },

    props: ['value', 'fileUploadUrl', 'fileDeleteUrl'],

    data() {
        return {
            expense: {
                ...{
                    amount: [0, 0],
                    currency: null,
                    domestic: null,
                    deduction: [0, 0],
                }, ...this.value,
            },
            currencies: [],
        }
    },

    mounted() {
        this.fetchSources();
    },

    computed: {
        ...mapState(['employee']),

        commonCurrencies() {
            return this.currencies.filter(currency => currency.hasOwnProperty('common'))
        },

        sortedCurrencies() {
            let currencies = this.currencies.filter(currency => !currency.hasOwnProperty('common'));
            const list = _.sortBy(currencies, 'currency').reverse();
            return _.sortBy(list, 'currency').reverse().map(item => item.currency);
        }
    },

    methods: {

        fetchSources() {
            if (!this.currencies.length) {
                this.$api('expenses').get('/sources?type=currencies')
                    .then(({data: {data}}) => {
                        this.currencies = data;
                    })
            }
        },
    }
}
</script>

<style lang="scss" scoped>
input[type=number] {
    -moz-appearance: textfield;
}

.amount-int-input {
    min-width: 0;
}
</style>
